<template>
  <tr>
    <td class="tight">
      <input
        v-model="candidate.selected"
        type="checkbox"
      >
    </td>
    <td
      v-if="hasErrorColumn"
      class="tight text-danger"
    >
      <span
        v-if="hasErrors"
        class="material-icons error"
        data-bs-toggle="tooltip"
        :data-bs-title="errorMessage"
      />
    </td>
    <td class="tight">{{ idx }}</td>
    <td
      v-for="column in columns"
      :key="column.id"
    >
      {{ candidate.attributes[column.id] }}
    </td>
    <td class="table-actions">
      <button
        type="button"
        class="btn btn-sm btn-success"
        @click.prevent="$emit('edit', candidate)"
      >
        Edit
      </button>
    </td>
  </tr>
</template>

<script setup lang="ts">

  import { computed } from "vue";
  import type { Column, ImportedCandidate } from "./candidates-import-types";


  const props = defineProps({
    idx: { default: null, type: Number },
    candidate: { default: function(): ImportedCandidate { return { id: "", selected: false, attributes: {}, links: { editModal: "" } } }, type: Object as () => ImportedCandidate },
    columns: { default: function (): Column[] { return [] }, type: Array as () => Column[] },
    hasErrorColumn: { default: false, type: Boolean }
  })

  defineEmits<{
    edit: [candidate: ImportedCandidate]
  }>()

  const hasErrors = computed((): boolean => {
    const errors = props.candidate?.attributes?.error_messages
    return Array.isArray(errors) && errors.length > 0
  })

  const errorMessage = computed((): string => {
    const messages = []
    const errorMessages = props.candidate?.attributes?.error_messages
    if (Array.isArray(errorMessages)) {
      for(const msg of errorMessages) {
        messages.push(msg[1])
      }
    }
    return messages.join('; ')
  })
</script>
